import { useNavigate, useLocation } from "react-router-dom";
import { useAdmin } from "../contexts/AdminContext";
import { ShieldCheck, BookOpen, Feather, MessageSquareQuote, User } from "lucide-react";

const TABS = [
  {
    key: "library",
    label: "Library",
    path: "/witness-stand",
    matches: (p) => p === "/witness-stand" || p === "/witness-stand/library",
    icon: BookOpen,
    blurb: "Browse stories published by listeners — free to read.",
  },
  {
    key: "write",
    label: "Publish a Story",
    path: "/witness-stand/write",
    matches: (p) => p.startsWith("/witness-stand/write"),
    icon: Feather,
    blurb: "Write & publish your own short story. Reviewed by our editors.",
  },
  {
    key: "testimony",
    label: "Submit Testimony",
    path: "/witness-stand/inspiration",
    matches: (p) => p.startsWith("/witness-stand/inspiration"),
    icon: MessageSquareQuote,
    blurb: "Share a real-life notary case anonymously — earn 10 credits if we adapt it.",
  },
  {
    key: "my",
    label: "My Stories",
    path: "/witness-stand/my",
    matches: (p) => p.startsWith("/witness-stand/my"),
    icon: User,
    blurb: "Your drafts, pending submissions, and published stories.",
  },
];

export default function WitnessStandTabs({ showBlurb = true }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAdmin } = useAdmin();
  const active = TABS.find((t) => t.matches(location.pathname)) || TABS[0];

  return (
    <div className="mb-6" data-testid="witness-stand-tabs">
      <div className="flex flex-wrap gap-1 text-xs">
        {TABS.map((t) => {
          const Icon = t.icon;
          const isActive = t.matches(location.pathname);
          return (
            <button
              key={t.key}
              onClick={() => navigate(t.path)}
              className={`flex items-center gap-1.5 px-3 py-2 rounded-lg transition-colors ${
                isActive
                  ? "bg-red-600 text-white font-bold"
                  : "bg-white/5 hover:bg-white/10 text-gray-300"
              }`}
              data-testid={`tab-${t.key}`}
            >
              <Icon size={11} />
              {t.label}
            </button>
          );
        })}
        {isAdmin && (
          <button
            onClick={() => navigate("/witness-stand/moderate")}
            className={`flex items-center gap-1.5 px-3 py-2 rounded-lg transition-colors ${
              location.pathname === "/witness-stand/moderate"
                ? "bg-amber-600 text-white font-bold"
                : "bg-amber-500/15 border border-amber-500/30 hover:bg-amber-500/25 text-amber-300"
            }`}
            data-testid="tab-moderate"
          >
            <ShieldCheck size={11} />
            Moderate
          </button>
        )}
      </div>
      {showBlurb && active && (
        <p className="text-[11px] text-gray-500 mt-2 font-mono" data-testid="tab-blurb">
          ▸ {active.blurb}
        </p>
      )}
    </div>
  );
}
